export const APP_TITLE = "Дашборд";

export const NAV_LINKS = [
  { path: "/", label: "Выход" },
  { path: "/postoplat", label: "Оплаты" },
  { path: "/debitor", label: "Счета" },
  { path: "/overdue", label: "Просроченная ДЗ" },
  { path: "/mops", label: "Панель МОПов" },
  { path: "/openRev", label: "Открытая выручка" },
  { path: "/openProfit", label: "Открытая прибыль" },
  { path: "/orderSuppliers", label: "Заказ поставщику" },
  { path: "/managerForm", label: "Форма" },
  { path: "/reports", label: "Отчёты" },
  { path: "/profit", label: "Прибыль" },
  { path: "/potential", label: "Потенциал" },
  { path: "/pdz", label: "Карточки счетов" },
  { path: "/uploadProfit", label: "Загрузки" },
  { path: "/staff", label: "Сотрудники" },
  { path: "/rights", label: "Права" },
  { path: "/logs", label: "Логи" },
];

const ROUTE_TITLES = Object.fromEntries(
  NAV_LINKS.map(({ path, label }) => [path, label])
);
ROUTE_TITLES["/dashboard"] = "Дашборд";

export function getDocumentTitle(pathname) {
  const title = ROUTE_TITLES[pathname];
  if (!title) {
    return APP_TITLE;
  }
  return `${title} | ${APP_TITLE}`;
}